'use strict';
function _classCallCheck(e, t) {
    if (!(e instanceof t))
        throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, t) {
    for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function _createClass(e, t, n) {
    return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var Event = function () {
    function e() {
        _classCallCheck(this, e), this.events = {};
    }
    return _createClass(e, [{key:"on",value:function(e,t){var n=this;return this.events[e]||(this.events[e]=[]),this.events[e].push(t),function(){n.off(e,t)}}},{key:"off",value:function(e,t){this.events[e]&&(this.events[e]=void 0===t?[]:this.events[e].filter(function(e){return t!==e}))}},{key:"trigger",value:function(e){for(var t=arguments.length,n=new Array(1<t?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];this.events[e]&&this.events[e].forEach(function(e){return e.apply(void 0,n)})}}]), e;
}();
exports.default = Event;